import { dcSecurityRights, SummaryOptions } from '@nibras/core/common';
import { IComponent } from './app.model';
import {
  AttributeOrTemplate,
  BaseAttributeOrTemplateHeader,
  IAttributeTemplateHeader
} from './common.interfaces';
import { dcDataStoreItem } from './datastore-item.model';
import { dcAttributeFilterTVP } from './dcattribute-filter-tvp.model';
import { dcAttributeDataKey } from './dcAttributeDataKey.model';
import { IdcAttributeTemplate } from './dcAttributeTemplate.model';
import { dcDataReference } from './dcdataReference.model';
import { dcQueryParameter } from './dcqueryParameter.model';
import { dcTag } from './dcTag.model';
import { ValueStyle } from './dcvalue.model';
import { suggestedDropDown } from './suggested-dropdown.model';

export class dcAttributeGeneric<T extends dcAttributeHeader>
  implements IdcAttributeTemplate, dcDataStoreItem
{
  Key?: string;
  Header: T;
  DataReference?: dcDataReference;
  Tags?: dcTag[];
  constructor() {
    this.Header = new dcAttributeHeader() as T;
    this.DataReference = new dcDataReference();
    this.Tags = [];
  }
}

export class dcAttribute extends dcAttributeGeneric<dcAttributeHeader> {}

export class DisplayAttribute extends dcAttributeGeneric<DisplayAttributeHeader> {}

export class dcAttributeHeader
  extends BaseAttributeOrTemplateHeader
  implements IAttributeTemplateHeader, IFormatting
{
  ElementName: string;
  ElementVersionID: number;
  AttributeID: number;
  ParentAttributeID: number;
  ReferenceElementTemplateVersionID: number;
  Security: dcSecurityRights;
  Value: any;
  ElementPath: string;
  AttributePath: string;
  RootElementVersionID: number;
  ReferenceElementVersionID: number;
  RootElementName: string;
  ParentElementVersionID: number;
  ChildElementVersionID?: number;
  ActualRootElementName: string;
  ActualRootElementVersionID: number;
  //Client-side properties
  //colorCode: string;
  QueryID?: number;
  QueryOperation: number;
  QueryOrder?: number;
  dataKey: dcAttributeDataKey;
  configuration: IComponent;
  isHidden = false;
  isReadOnly = false;
  showAsLabel = false;
  isDisplayTime = false;
  isLoading: boolean;
  style: ValueStyle;
  orientation: string;
  isHideValue = false;
  alignLabelRight = false;
  SliderCombinedCell: string;
  IsTrendable: boolean;
  SummaryOption: SummaryOptions;
  ValueFilter: string;
  labelStyleCss?: Record<string, string>;
  use1000Seperator = false;
}

export class DisplayAttributeHeader extends dcAttributeHeader {
  public displayValue: string;
  public dropdownOptions?: suggestedDropDown[];
  public actionType?: number;
  public isUniqueColumn?: boolean;
  public AttributeDataKey?: string;
  public rowUniqueId?: string;
  public enableEditingForRowGroup?: boolean;
}

export interface IFormatting {
  style: ValueStyle;
}

export class AttributeOverride {
  public Id: number;
  public Name: string;
  public ParentId: number;
}

export class dcAttributeHeaderExt extends dcAttributeHeader {
  headerName?: string;
}

export class dcSubstitutionParameter {
  Attributes: dcAttributeFilterTVP[];
  SubstitutionParameterInput: string;
  QueryParameterName: string;
  ResolvedOutput: string;
  Status: boolean;
  StatusMessage: string;
  constructor(attribute: AttributeOrTemplate, queryParam: dcQueryParameter) {
    const filter = new dcAttributeFilterTVP();
    filter.ElementPath = attribute.Header.ElementPath;
    filter.AttributeTemplatePath = attribute.Header.AttributeTemplatePath;
    filter.RootElementVersionID = attribute.Header.RootElementVersionID;
    filter.QueryOperation = queryParam.Header.QueryOperation;
    filter.QueryOrder = queryParam.Header.QueryOrder;

    this.Attributes = [filter];
    this.SubstitutionParameterInput = queryParam.Header.isDirty
      ? queryParam.Header.ValueString
      : '';
    this.QueryParameterName = queryParam.Header.AttributeTemplateName;
    this.ResolvedOutput = '';
    this.Status = false;
    this.StatusMessage = '';
  }
}
